import { useQuery } from 'react-query';

import { getCompletionPlanFragnetMilestones as queryFn } from 'api/endPoints/getCompletionPlanFragnetMilestones';
import { QueryKeys } from 'api/queryKeys';

export const useQueryGetCompletionPlanFragnetMilestones = (params: QueryParams) => {
    return useQuery<QueryResponse[], QueryError, QueryResponse[], [QueryKeys, unknown]>({
        queryKey: ['getCompletionPlanFragnetMilestones', params],
        queryFn: () =>
            queryFn({
                latestVersion: params.latestVersion as number,
                filter: params.filter,
            }),
        enabled: Boolean(params.latestVersion),
    });
};

export interface QueryResponse {
    id: number;
    activity_id: string;
    name: string;
    activity_status: string;
    activity_type: string;
    preceding_activities: number;
    succeding_activities: number;
    task_version_hash_code: string;
}

interface QueryParams {
    latestVersion?: number;
    filter: string;
}
